module.exports = __webpack_public_path__ + "img/icon3.ff565a23.png";